import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { getCommentListEP, getEdPPDF_PolinomioList, getEdPPrepare_DIList, getEdPPrepare_PartiesList, getEdPPrepare_ResultList, getHeaderEP, getNotasChecklistEP, getRevisionEP, getTiposNotaChecklistEP, Obtener_Ambiente_EP } from '../../../services/sPay/edpConfig.service';
import { action_updateEdpPrepareResult, action_updateEdpPrepareParties, action_updateEdpPrepareDI, action_updateEdPPrepareErrorValidations, action_updateFirstLoad, action_updateEdpPrepareAmbiente, action_updateEdpPrepareHeader, action_updateEdPPrepareManageButtons, action_updateEdPPrepareForceGetHeader, action_updateEdPPrepareForceGetResult, action_updateEdPPrepareForceGetButtons, action_updateEdPPrepareForceGetParties } from '../../../reducers/actions/PAY/edpPrepareActions';
import { isNullUndefinedOrEmptyOrZero } from '../../../common/Helpers';
import { enum_ENUM_ESTADO_EP, enum_ENUM_FLUJO_EP, enum_ENUM_ICONO_REVISION, enum_ENUM_TIPO_ROLES_SEGURIDAD } from '../../../common/Dictionaries';

export const useGetEdPResult = (elementId, edpPId, edpResultList, forceGet_PrepareResult) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            dispatch(action_updateEdPPrepareForceGetResult(false));

            try {
                let serviceesponse = await getEdPPrepare_ResultList(elementId, edpPId);

                if (serviceesponse.data.succeeded) {
                    dispatch(action_updateEdpPrepareResult(serviceesponse.data.data));
                    dispatch(action_updateFirstLoad(true, '_firsLoadResult'));
                }
                else {
                    dispatch(action_updateEdpPrepareResult([]));
                    dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                }
            }
            catch (error) {
                dispatch(action_updateEdpPrepareResult([]));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                dispatch(action_updateFirstLoad(false, '_firsLoadResult'));
            }
        }
        
        if (elementId !== null && (edpResultList === null || forceGet_PrepareResult)) {
            doIt()
        }
    }, [elementId, edpPId, edpResultList, forceGet_PrepareResult]);
}

export const useGetEdPResultDI = (edpId, edpDIList) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getEdPPrepare_DIList(edpId);

                if (serviceResponse.data.succeeded) {
                    dispatch(action_updateEdpPrepareDI(serviceResponse.data.data));
                    dispatch(action_updateFirstLoad(true, '_firsLoadDI'));
                }
                else {
                    dispatch(action_updateEdpPrepareDI([]));
                    dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                }
            }
            catch (error) {
                dispatch(action_updateEdpPrepareDI([]));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                dispatch(action_updateFirstLoad(false, '_firsLoadDI'));
            }
        }
        
        if (edpId !== null && edpDIList === null) {
            doIt()
        }
    }, [edpId, edpDIList]);
}

export const useGetEdPResultParties = (edpId, edpPartiesList, forceGet) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getEdPPrepare_PartiesList(edpId, false, false);

                if (serviceResponse.data.succeeded) {
                    dispatch(action_updateEdPPrepareForceGetParties(false));
                    dispatch(action_updateEdpPrepareParties(serviceResponse.data.data));
                    dispatch(action_updateFirstLoad(true, '_firsLoadParties'));
                }
                else {
                    dispatch(action_updateEdPPrepareForceGetParties(false));
                    dispatch(action_updateEdpPrepareParties([]));
                    dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                }
            }
            catch (error) {
                dispatch(action_updateEdPPrepareForceGetParties(false));
                dispatch(action_updateEdpPrepareParties([]));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                dispatch(action_updateFirstLoad(false, '_firsLoadParties'));
            }
        }
        
        if (edpId !== null && (edpPartiesList === null || forceGet === true)) {
            doIt()
        }
    }, [edpId, edpPartiesList, forceGet]);
}

export const useGetEdPPolinomios = (elementId, edpId, edpPolinomioList, setEdpPolinomioList) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getEdPPDF_PolinomioList(elementId, edpId);

                if (serviceResponse.data.succeeded) {
                    setEdpPolinomioList(serviceResponse.data.data);
                }
                else {
                    setEdpPolinomioList([])
                }
            }
            catch (error) {
                setEdpPolinomioList([])
            }
        }
        
        if (elementId !== null && edpId !== null && (edpPolinomioList === null)) {
            doIt()
        }
    }, [elementId, edpId, edpPolinomioList, setEdpPolinomioList]);
}

export const useCargarAmbiente = (edpId, executeCargarAmbiente, setExecuteCargarAmbiente) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await Obtener_Ambiente_EP(edpId);

                if (serviceResponse.data.succeeded) {
                    setExecuteCargarAmbiente(false)
                    dispatch(action_updateEdpPrepareAmbiente(serviceResponse.data.data));
                }
                else {
                    setExecuteCargarAmbiente(false)
                    dispatch(action_updateEdpPrepareAmbiente(null));
                }
            }
            catch (error) {
                setExecuteCargarAmbiente(false)
                dispatch(action_updateEdpPrepareAmbiente(null));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
            }
        }
        
        if (edpId !== null && executeCargarAmbiente === true) {
            doIt()
        }
    }, [edpId, executeCargarAmbiente, setExecuteCargarAmbiente]);
}

export const useGetHeaderEP = (elementId, edpId, headerEdP, forceGet_PrepareHeader) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            console.log();
            try {
                console.log();
                let serviceResponse = await getHeaderEP(elementId, edpId);
                console.log();

                if (serviceResponse.data.succeeded) {
                    dispatch(action_updateEdpPrepareHeader(serviceResponse.data.data));
                    if (headerEdP !== null) {
                        dispatch(action_updateEdPPrepareForceGetHeader(false));
                    }
                }
                else {
                    dispatch(action_updateEdpPrepareHeader(null));
                    if (headerEdP !== null) {
                        dispatch(action_updateEdPPrepareForceGetHeader(false));
                    }
                }
            }
            catch (error) {
                dispatch(action_updateEdpPrepareHeader(null));
                dispatch(action_updateEdPPrepareErrorValidations(['data-lang-msg-operationerror']));
                if (headerEdP !== null) {
                    dispatch(action_updateEdPPrepareForceGetHeader(false));
                }
            }
        }
        
        if (elementId !== null && edpId !== null && (headerEdP === null || forceGet_PrepareHeader)) {
            doIt()
        }
    }, [elementId, edpId, headerEdP, forceGet_PrepareHeader]);
}

export const useOfGetEdPCommentList = (edpId, edpPartidaId, edpIncrementoId, edpDeduccionId, commentList, setCommentList) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getCommentListEP(edpId, edpPartidaId, edpIncrementoId, edpDeduccionId);

                if (serviceResponse.data.succeeded) {
                    setCommentList(serviceResponse.data.data);
                }
                else {
                    setCommentList([]);
                }
            }
            catch (error) {
                setCommentList([]);
            }
        }
        
        if ((edpId !== null || edpPartidaId != null || edpIncrementoId != null || edpDeduccionId != null) && commentList === null) {
            doIt()
        }
    }, [edpId, edpPartidaId, edpIncrementoId, edpDeduccionId, commentList, setCommentList]);
}

export const useOfGetEdPChecklistNotaList = (elementId, edpId, notaList, setNotaList) => {
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getNotasChecklistEP(elementId, edpId);

                if (serviceResponse.data.succeeded) {
                    setNotaList(serviceResponse.data.data);
                }
                else {
                    setNotaList([]);
                }
            }
            catch (error) {
                setNotaList([]);
            }
        }

        if (elementId !== null && edpId !== null && notaList === null) {
            doIt()
        }
    }, [elementId, edpId, notaList, setNotaList]);
}

export const useGetTiposNotaChecklistMaintainer = (tipoList, setTipoList) => {
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getTiposNotaChecklistEP();

                if (serviceResponse.data.succeeded) {
                    setTipoList(serviceResponse.data.data);
                }
                else {
                    setTipoList([]);
                }
            }
            catch (error) {
                setTipoList([]);
            }
        }

        if (tipoList === null) {
            doIt()
        }
    }, [tipoList, setTipoList]);
}

export const useGetPartieDiRevisionObject = (search, elementid, edPId, rolTipoRespuestaId, estadoPagoPartidaId, estadoPagoCompuestaDiId, iteracion, objRevision, setObjRevision, edpIatrizEtapaId, tipoRespuestaId) => {    
    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getRevisionEP(elementid, edPId, estadoPagoPartidaId, estadoPagoCompuestaDiId, rolTipoRespuestaId, iteracion, edpIatrizEtapaId, tipoRespuestaId);

                if (serviceResponse.data.succeeded) {
                    const obj = serviceResponse.data.data
                    if (obj.id === 0) {
                        obj.aprobar = null;
                    }
                    setObjRevision(obj);
                }
                else {
                    setObjRevision && setObjRevision(prevState => ({
                        ...prevState,
                        id : 0,
                        aprobar: null
                    }));
                }
            }
            catch (error) {
                setObjRevision && setObjRevision(prevState => ({
                    ...prevState,
                    id : 0,
                    aprobar: null
                }));
            }
        }
        
        if (search === true && elementid !== null && edPId !== null && rolTipoRespuestaId !== null && iteracion !== null && objRevision.id === null) {
            doIt()
        }
    }, [search, elementid, edPId, rolTipoRespuestaId, estadoPagoPartidaId, estadoPagoCompuestaDiId, iteracion, objRevision, setObjRevision, edpIatrizEtapaId, tipoRespuestaId]);
}

export const useCargarVista = (edpPrepareErrorValidations, edpPrepareHeader, es_admin, edpPrepareManageButtons, forceGet_PrepareButtons) => {
    const dispatch = useDispatch();

    useEffect(()=> {
        let buttons = {
            filled: true,
            btnEliminarRevisionVisible: false,
            btnAnularRevisionVisible: false,
            btnEnviarRevisionVisible: false,
            btnTerminarRevisionVisible: false,
            tblhtmlAprobarVisible: false,
            tblhtmlRevisionDinamicaVisible: false
        }
        
        const Cargar_Vista = () => {
            if (edpPrepareHeader.etapa_ep.indexOf("Inicializar_Etapa_Preparacion") !== -1) {
                Inicializar_Etapa_AEC();
            }
            else if (edpPrepareHeader.etapa_ep.indexOf("Inicializar_Etapa_Revision") !== -1) {
                Inicializar_Etapa_ATO_AAD();
            }

            if (edpPrepareHeader.etapa_ep.indexOf("Inicializar_Etapa_Aprobacion") !== -1) {
                Inicializar_Etapa_ADN_RFA();
            }

            if (edpPrepareHeader.etapa_ep === "") {
                Inicializar_Etapa_Aprobado();
            }
        
            if ((edpPrepareHeader.estadO_ID === enum_ENUM_ESTADO_EP.PREPARACION || edpPrepareHeader.estadO_ID === enum_ENUM_ESTADO_EP.PREPARACION_SIMULADO) & edpPrepareHeader.etapA_FLUJO_ID == enum_ENUM_FLUJO_EP.PREPARACION) {
                if (es_admin || edpPrepareHeader.puede_eliminar_ep) {
                    buttons.btnEliminarRevisionVisible = true;
                }
            }
        
            if ((edpPrepareHeader.estadO_ID === enum_ENUM_ESTADO_EP.ANULADO) & edpPrepareHeader.etapA_FLUJO_ID == enum_ENUM_FLUJO_EP.ANULADO) {
                buttons.btnEliminarRevisionVisible = edpPrepareHeader.es_aad_valido;
            }

            if ((edpPrepareHeader.etapA_FLUJO_ID  == enum_ENUM_FLUJO_EP.PREPARACION || edpPrepareHeader.etapA_FLUJO_ID  == enum_ENUM_FLUJO_EP.RECHAZADO) && (edpPrepareHeader.estadO_ID == enum_ENUM_ESTADO_EP.PREPARACION || edpPrepareHeader.estadO_ID == enum_ENUM_ESTADO_EP.PREPARACION_SIMULADO || edpPrepareHeader.estadO_ID == enum_ENUM_ESTADO_EP.ANULADO)) {
                if (edpPrepareHeader.autofacturacion) {
                    //if (es_admin | edpPrepareHeader.l_rol.filter(x => x === "ATO").length > 0)
                    if (es_admin | edpPrepareHeader.es_ato |
                        ((edpPrepareHeader.conF_ROL_INGRESO_DI === "AAD" && edpPrepareHeader.es_aad) || (edpPrepareHeader.conF_ROL_INGRESO_DI === "AEC" && edpPrepareHeader.es_aec) || (edpPrepareHeader.conF_ROL_INGRESO_DI === ""))
                    )
                        buttons.btnIngresarDatosEPVisible = true;
                    else {
                        buttons.btnIngresarDatosEPVisible = false;
                    }
                }
                else {
                    //if (es_admin | edpPrepareHeader.l_rol.filter(x => x === "AEC").length > 0) {
                    if (es_admin || edpPrepareHeader.es_aec |
                        ((edpPrepareHeader.conF_ROL_INGRESO_DI === "AAD" && edpPrepareHeader.es_aad) || (edpPrepareHeader.conF_ROL_INGRESO_DI === "AEC" && edpPrepareHeader.es_aec) || (edpPrepareHeader.conF_ROL_INGRESO_DI === ""))
                    ) {

                        buttons.btnIngresarDatosEPVisible = true;
                    }
                    else {
                        buttons.btnIngresarDatosEPVisible = false;
                    }
                }
            
                if (edpPrepareHeader.conF_PERMITE_DI) {
                    if (edpPrepareHeader.conF_ROL_INGRESO_DI == enum_ENUM_TIPO_ROLES_SEGURIDAD.AEC) {
                        //if (es_admin | edpPrepareHeader.l_rol.filter(x => x === "AEC").length > 0)
                        if (es_admin | edpPrepareHeader.es_aec)
                            buttons.btnIngresarDatosEPVisible = true;
                    }
                    else if (edpPrepareHeader.conF_ROL_INGRESO_DI == enum_ENUM_TIPO_ROLES_SEGURIDAD.AAD)
                    {
                        //if (es_admin | edpPrepareHeader.l_rol.filter(x => x === "AAD").length > 0)
                        if (es_admin | edpPrepareHeader.es_aad)
                            buttons.btnIngresarDatosEPVisible = true;
                    }
                }
            }

            dispatch(action_updateEdPPrepareForceGetButtons(false))
            dispatch(action_updateEdPPrepareManageButtons(buttons))
        }

        const Inicializar_Etapa_AEC = () => {
            let mensaje = null;

            if ((edpPrepareHeader.conF_PERMITE_DI ?? false) && edpPrepareHeader.estadO_ID === enum_ENUM_ESTADO_EP.PREPARACION_SIMULADO && !es_admin)
            {
                buttons.btnEnviarRevisionVisible = edpPrepareHeader.puede_enviar_revision_ep;
                if (!edpPrepareHeader.puede_enviar_revision_ep)
                {
                    mensaje = "Se requiere que el rol " + edpPrepareHeader.conF_ROL_INGRESO_DI + " envíe el EP a revisión.";
                    if (edpPrepareErrorValidations !== null) {
                        edpPrepareErrorValidations.push(mensaje)
                        dispatch(action_updateEdPPrepareErrorValidations(edpPrepareErrorValidations));
                    }
                    else {
                        dispatch(action_updateEdPPrepareErrorValidations([mensaje]));
                    }
                }
            }
            else
            {
                if (edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.RECHAZADO) {
                    buttons.tblhtmlRevisionDinamicaVisible = true;
                    buttons.tblhtmlAprobarVisible = true;
                }
                buttons.btnEnviarRevisionVisible = true;
            }
        
            if (edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.RECHAZADO)
            {
                buttons.btnAnularRevisionVisible = edpPrepareHeader.puede_anular_ep;
            }
        }

        const Inicializar_Etapa_ATO_AAD = () => {
            if (edpPrepareHeader.es_ato_valido || edpPrepareHeader.es_aad_valido || es_admin)
            {
                buttons.btnTerminarRevisionVisible = true;
            }
            buttons.tblhtmlRevisionDinamicaVisible = true;
        }

        const Inicializar_Etapa_ADN_RFA = () => {  
            if ((edpPrepareHeader.respuesta_adn_rfa && edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.RECHAZADO) ||
                (edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_ADN || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA1 || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA2 || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA3))
            {
                buttons.tblhtmlAprobarVisible = true;
            }

            if ((edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_ADN || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA1 || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA2 || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ABROPACION_RFA3))
            {
                buttons.tblhtmlRevisionDinamicaVisible = true;
            }
        }

        const Inicializar_Etapa_Aprobado = () => {  
            if (edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.APROBADO || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.APROBADO_COMUNICADO || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.ANULADO || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.RECHAZADO || edpPrepareHeader.etapA_FLUJO_ID === enum_ENUM_FLUJO_EP.HISTORICO)
            {
                buttons.tblhtmlAprobarVisible = true;
                buttons.tblhtmlRevisionDinamicaVisible = true;
            }
        }

        if ((edpPrepareManageButtons.filled === false || forceGet_PrepareButtons) && edpPrepareHeader !== null) {
            Cargar_Vista();
        }
    }, [edpPrepareErrorValidations, edpPrepareHeader, es_admin, edpPrepareManageButtons]);
}